window.addEventListener("DOMContentLoaded", () => {
    const el = $('.modal-with-errors').parents('aside.modal');
    if (el.length > 0) {
        //@ts-ignore
        el.modal('show');
    }
});
